import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/apply/img-file-delete.svg'
import _imports_1 from '@/assets/img/apply/icon-checked.svg'
import _imports_2 from '@/assets/img/common/img-pagetop.svg'


const _withScopeId = n => (_pushScopeId("data-v-78e4e866"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "l-wrapper",
  style: {"background-color":"#f3f3f3"}
}
const _hoisted_2 = { class: "l-wrapper_main" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "一括応募辞退", -1))
const _hoisted_4 = { class: "p-apply" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "p-apply_headingLv1 u-mn-hidden" }, "一括応募辞退", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "p-apply_text" }, "応募辞退する求人をいま一度ご確認ください。", -1))
const _hoisted_7 = { class: "p-apply_number" }
const _hoisted_8 = { class: "p-apply-card -multiple" }
const _hoisted_9 = { class: "p-apply-card_heading" }
const _hoisted_10 = { class: "p-apply_button-wrap" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "u-mn-hidden p-apply_button" }, "応募しない", -1))
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = {
  class: "c-modal js-modal-container",
  id: "apply"
}
const _hoisted_14 = {
  class: "c-modal_inner",
  style: {"max-width":"400px"}
}
const _hoisted_15 = { class: "c-modal_content" }
const _hoisted_16 = { class: "js-apply-tab" }
const _hoisted_17 = { class: "p-apply-modal" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-apply-modal_img" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1))
const _hoisted_19 = {
  key: 0,
  class: "p-apply-modal_heading"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", { class: "u-lg-hidden" }, null, -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_23 = ["innerHTML"]
const _hoisted_24 = { class: "js-apply-tab" }
const _hoisted_25 = { class: "p-apply-modal" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-apply-modal_img" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: ""
  })
], -1))
const _hoisted_27 = { class: "p-apply-modal_heading" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_29 = ["innerHTML"]
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "c-modal_bg" }, null, -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "l-wrapper_nav" }, [
  /*#__PURE__*/_createElementVNode("a", {
    class: "g-to-top",
    href: "#",
    "aria-label": "ページトップへ戻る"
  }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_2,
      alt: ""
    })
  ])
], -1))

import { onBeforeUnmount, onMounted, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { MultipleOrderRefusal, OrderInfo, OrderRefusal, UpdateResponse } from '@/types';
import { submitUpdateRefusalShintyokuService } from '@/api/services/shintyokuService';
import { getOrdersDetail } from '@/api/shintyokuEndpoint';
import { eventBus } from '@/events/eventBus';
import Loading from '@/components/Loading.vue';
import { MYPAGE_CONSTANTS } from '../../constants/mypage';
import { mypageUtils } from '@/utils/mypage';
import { useStore } from 'vuex';

// Ref

export default /*#__PURE__*/_defineComponent({
  __name: 'RefusalMultipleView',
  setup(__props) {

const btnRefusal = ref<HTMLButtonElement | null>(null);
const orderRefusals = ref<MultipleOrderRefusal[]>([]);
const orderSuccess = ref<MultipleOrderRefusal[]>([]);
const orderInfos = ref<OrderInfo[]>([]);

// Modal Events
const showModal = ref(false);
const isConfirmed = ref(false);
const btnClose = ref(true);
const errorMessage = ref('');
const successMessage = ref('0');
const submitSuccess = ref(false);
const isLoading = ref<boolean>(false);
const isExistSuscess = ref<boolean>(false);
const store = useStore();

// Route => Get Params
const route = useRoute();
const router = useRouter();

let orderIds: number[] = [];
if (Array.isArray(route.query.orderIds)) {
  orderIds = route.query.orderIds.map(Number);
} else if (route.query.orderIds) {
  orderIds = route.query.orderIds.split(',').map(Number);
}

const handleShowTitleSuccess = (size: number, ) => {
  return size > 1 ? ' ほか' : ''; 
};

// Methods
/**
 * Show modal to confirm Refusal
 * @param isShow
 */
const handleShow = (isShow: boolean) => {
  showModal.value = isShow;
  btnClose.value = !isShow;
};

const handleInitConfirm = () => {
  resetValueRef();
  handleShow(true);
};

const handleBack = () => {
  window.history.back();
};

const handleLeaveForm = () => {
  if (submitSuccess.value) {
    router.push('/refusallist/');
    return;
  }
  if(isExistSuscess.value)
  {
      errorMessage.value = '';
      isExistSuscess.value = false;
      isConfirmed.value = true;
      submitSuccess.value = true;
  }
  else
  {
    resetValueRef();
  }
};

/**
 * Reset value refs
 */
const resetValueRef = () => {
  showModal.value = false;
  isConfirmed.value = false;
  btnClose.value = true;
  errorMessage.value = '';
  submitSuccess.value = false;
  document.body.style.overflow = '';
  isExistSuscess.value = false;
};

/**
 * Handles the click event for the refusal button in the footer.
 * If the status message is 'ACTIVE', programmatically clicks the refusal button.
 *
 * @param msg - The status message to check
 */
function handleClickButtonRefusalFromFooter(msg: string) {
  if (msg === 'ACTIVE') {
    resetValueRef();
    btnRefusal.value?.click();
  }
}

const handleClickOutSideModal = (event: Event) => {
  const target = event.target as Element | null;
  // Check if the click was inside the model-confirm-form div
  if (target && !target.closest('.c-modal_inner') && submitSuccess.value) {
    router.push('/refusallist/');
    return;
  }
};

onMounted(async () => {
  // If there are no orderIds or the orderIds are not valid numbers,
  // redirect to the 404 page and exit
  if (orderIds.length === 0 || !handleCheckParamValidNumbers(orderIds)) {
    router.replace({ path: 'mynavi/404' });
    return;
  }
  // Enable event
  eventBus.on('click-refusal-event', handleClickButtonRefusalFromFooter);
  isLoading.value = true;
  // For each orderId, fetch the company name and job title,
  // then add a MultipleOrderRefusal object to orderRefusals
  const orders : OrderInfo[] = await getOrdersDetail({orderIds: orderIds});
  for (const orderId of orderIds) {
    const orderInfo = orders.find(v => v.orderId === orderId);
    if (orderInfo) {
      orderInfos.value.push(orderInfo);
      const refusal: MultipleOrderRefusal = {
        orderRefusal: { orderId },
        orderRefusalName: orderInfo.clientName + '／' + orderInfo.positionname,
      };
      orderRefusals.value.push(refusal);
    }
  }
  isLoading.value = false;
  document.addEventListener('click', handleClickOutSideModal);
});
onBeforeUnmount(() => {
  eventBus.off('click-refusal-event', handleClickButtonRefusalFromFooter);
  document.removeEventListener('click', handleClickOutSideModal);
});

/**
 * Handles the submission of a refusal request.
 * If already confirmed, just resets values and returns.
 * Otherwise, prepares the request and submits it.
 */
const handleSubmitRefusal = async (): Promise<void> => {
  // If already confirmed, reset and exit
  if (isConfirmed.value) {
    if(isExistSuscess.value)
    {
       isExistSuscess.value = false;
       errorMessage.value = '';
       isConfirmed.value = true;
       submitSuccess.value = true;
    }
    else
    {
      resetValueRef();
    }
    return;
  }
  handleShow(false);
  isLoading.value = true;
  // Extract orderRefusal objects from orderRefusals
  const orders: OrderRefusal[] = orderRefusals.value.map((v) => v.orderRefusal);
  // Submit the refusal request
  const response = await submitUpdateRefusalShintyokuService(orders);
  // Show the result message to the user
  await handleShowMessage(response);
};

/*
 * Handles the display of messages based on the response from an update operation.
 * @param response - The response object from the update operation, or null if no response is available.
 */
const handleShowMessage = async (response: UpdateResponse | null) => {
  // Check if the response is null and handle the null case if needed
  if (!response) {
    // If there's no response, exit the function early
    return;
  }

  const arrError = [];

  // Check for ignored orders and set an error message if any are found
  if ((response.ignoreOrders ?? []).length > 0) {
    arrError.push(handleMessageForInvalidOrders(MYPAGE_CONSTANTS.STRING.IGNORED_ORDER_ERR_MESG_BULK, response.ignoreOrders));
  }

  // Check for unapproved orders and set an error message if any are found
  if ((response.unApprovedOrders ?? []).length > 0) {
    arrError.push(handleMessageForInvalidOrders(MYPAGE_CONSTANTS.STRING.NO_ACCESS_RIGHTS, response.unApprovedOrders));
  }

  // Check for unavailable orders and set an error message if any are found
  if ((response.unAvailableOrders ?? []).length > 0) {
    arrError.push(handleMessageForInvalidOrders(MYPAGE_CONSTANTS.STRING.NO_SEL_ON_BRIEFING_SESSION_MULTI, response.unAvailableOrders));
  }

  // Check for shintyoku update exception and set an error message if any are found
  if (typeof response.shintyokuUpdateException === 'string' && response.shintyokuUpdateException.length > 0) {
    arrError.push(handleMessage(MYPAGE_CONSTANTS.STRING.FAIL_UPDATE_PROGRESS_MSG));
  }

  // Check for other exceptions and set an error message if any are found
  if (typeof response.otherException === 'string' && response.otherException.length > 0) {
    arrError.push(handleMessage(MYPAGE_CONSTANTS.STRING.FAIL_REGISTER_PROGRESS_HISTORY_MSG));
  }

  if(arrError.length)
  {
    errorMessage.value = arrError.join('</br></br>');
  }
  
  let sucessOrderIds : number[] = [];
  if(response.detail && response.detail.orderIds && response.detail.orderIds.length > 0)
  {
    sucessOrderIds = response.detail.orderIds;
    orderSuccess.value = orderRefusals.value.filter(v=>sucessOrderIds.includes(v.orderRefusal.orderId??0));
  }
  successMessage.value = sucessOrderIds.length.toString() ?? '0';
    
  // Determine whether to show a confirmation or success message
  if (errorMessage.value.length > 0) {
    // If there is an error message, set the confirmation flag
    isConfirmed.value = true;
    submitSuccess.value = false;
    if(sucessOrderIds.length > 0)
    {
      isExistSuscess.value = true;
    }
    else
    {
      isExistSuscess.value = false;
    }
  } else {
    // If there are no error messages, set both confirmation and success flags
    isConfirmed.value = true;
    submitSuccess.value = true;
    document.body.style.overflow = '';
  }
  isLoading.value = false;
  handleShow(true);
};

/**
 * Appends detailed information for invalid order IDs to the given message.
 *
 * @param msg - The base message string.
 * @param invalidOrderIds - Array of invalid order IDs, or null.
 * @returns The message with additional details for each invalid order.
 */
const handleMessageForInvalidOrders = (msg: string, invalidOrderIds: number[] | null | undefined) => {
  if (invalidOrderIds === null || !invalidOrderIds) {
    return msg;
  }
  for (let orderId of invalidOrderIds) {
    const orderInfoResponse = orderInfos?.value?.find((e) => e.orderId === orderId);
    if (orderInfoResponse != null) {
      msg +=
        '<br/>' + orderId + ' : ' + orderRefusals.value.filter((v) => v.orderRefusal.orderId === orderId).map((v) => v.orderRefusalName);
    }
  }
  return msg;
};

/**
 * Generates a formatted message.
 *
 * @param msg - The base message to be displayed.
 * @returns A formatted string containing all provided details.
 */
const handleMessage = (msg: string): string => {
  return msg;
};
/**
 * Checks if the orderIds array contains only valid numbers and is not empty.
 *
 * @param orderIds - Array of order IDs to validate
 * @returns true if all elements are valid numbers and array is not empty, false otherwise
 */
const handleCheckParamValidNumbers = (orderIds: number[]): boolean => {
  return orderIds.length > 0 && orderIds.every((x) => !Number.isNaN(x));
};

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(Loading, { "is-loading": isLoading.value }, null, 8, ["is-loading"]),
      _createElementVNode("div", { class: "c-head-mn u-lg-hidden" }, [
        _createElementVNode("button", {
          onClick: handleBack,
          "aria-label": "戻る"
        }),
        _hoisted_3
      ]),
      _createElementVNode("main", _hoisted_4, [
        _hoisted_5,
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, [
          _createTextVNode(" 全"),
          _createElementVNode("span", null, _toDisplayString(orderRefusals.value.length), 1),
          _createTextVNode("件 ")
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(orderRefusals.value, (order) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "p-apply-card-list",
            key: order.orderRefusal.orderId
          }, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("p", _hoisted_9, _toDisplayString(order.orderRefusalName), 1)
            ])
          ]))
        }), 128)),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("button", {
            class: "u-modal-open-button js-modal-open-button",
            ref_key: "btnRefusal",
            ref: btnRefusal,
            "data-modal-target": "apply",
            type: "button",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (handleInitConfirm()))
          }, _hoisted_12, 512),
          _withDirectives(_createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("button", {
                class: "c-modal_close",
                type: "button",
                "aria-label": "閉じる",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (handleLeaveForm()))
              }),
              _createElementVNode("div", _hoisted_15, [
                _withDirectives(_createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("div", null, [
                      _hoisted_18,
                      (!isConfirmed.value)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_19, [
                            _createTextVNode(_toDisplayString(orderRefusals.value.length) + "件の求人が", 1),
                            _hoisted_20,
                            _createTextVNode("「応募しない求人一覧」に"),
                            _hoisted_21,
                            _createTextVNode("移動します。"),
                            _hoisted_22,
                            _createTextVNode("よろしいでしょうか？ ")
                          ]))
                        : (_openBlock(), _createElementBlock("p", {
                            key: 1,
                            class: "p-apply-modal_heading",
                            innerHTML: errorMessage.value
                          }, null, 8, _hoisted_23))
                    ]),
                    _createElementVNode("div", null, [
                      _createElementVNode("button", {
                        class: "p-apply-modal_button -apply",
                        type: "button",
                        onClick: handleSubmitRefusal
                      }, "OK"),
                      _withDirectives(_createElementVNode("button", {
                        class: "p-apply-modal_button",
                        type: "button",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (resetValueRef()))
                      }, " キャンセル ", 512), [
                        [_vShow, !isConfirmed.value]
                      ])
                    ])
                  ])
                ], 512), [
                  [_vShow, !submitSuccess.value]
                ]),
                _withDirectives(_createElementVNode("div", _hoisted_24, [
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("div", null, [
                      _hoisted_26,
                      _createElementVNode("p", _hoisted_27, [
                        _createTextVNode(_toDisplayString(successMessage.value) + " 件の応募辞退を ", 1),
                        _hoisted_28,
                        _createTextVNode(" 受け付けました ")
                      ])
                    ]),
                    _createElementVNode("p", {
                      class: "p-apply-modal_text",
                      innerHTML: orderSuccess.value.map((v) => v.orderRefusalName)[0] + handleShowTitleSuccess(orderSuccess.value.length)
                    }, null, 8, _hoisted_29),
                    _createElementVNode("div", null, [
                      _createVNode(_component_router_link, {
                        class: "p-apply-modal_button -apply",
                        to: "/refusallist/"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("応募しない求人一覧へ")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_router_link, {
                        class: "p-apply-modal_button -apply",
                        to: "/jobsearch/"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("求人一覧へ")
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ], 512), [
                  [_vShow, submitSuccess.value]
                ])
              ])
            ]),
            _hoisted_30
          ], 512), [
            [_vShow, showModal.value]
          ])
        ])
      ])
    ]),
    _hoisted_31
  ]))
}
}

})